class Zong {
    constructor() {
      this.items = [
        {
            id: "1",
            name: "Health Insurance",
            text: "Health Insurance Only For Rs. 12 + Tax daily",
            image: "/images/Zong/HealthIn.webp",
            price:"12",
            successtext: "Health Insurance For Rs. 12 + Tax daily",
            privacypolicy: "Health Insurance For Rs. 12 + Tax daily",
            serviceid: "3",
            api_service:"API_HIS"
        },
        {
            id: "2",
            name: "Mobile Insurance",
            text: "Mobile Insurance Only For Rs. 11.30 + Tax daily",
            image: "/images/Zong/MobileIn.webp",
            price:"11.30",
            successtext: "Mobile Insurance For Rs. 11.30 + Tax daily",
            privacypolicy: "",
            serviceid: "3",
            api_service:"API_MIS"
        },
        
      ];
    }
  
    getAllItems() {
      return this.items;
    }
    getItemById(id) {
        const item = this.items.find(i => i.id === id);
        if (!item) {
          return `Item with id ${id} not found.`; // Custom error message
        }
        return item;
      }
  }
  
  export default Zong;
  